import { lazy } from 'react';

const CharityInformationRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityInformation" */ '../components/steps/charity-information-step/CharityInformation'
    ),
);

export default CharityInformationRoute;
